import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Maximize2 = createReactComponent("Maximize2", ["svg", defaultAttributes, [["polyline", {
  points: "15 3 21 3 21 9",
  key: "8bv4a6"
}], ["polyline", {
  points: "9 21 3 21 3 15",
  key: "qq2vbi"
}], ["line", {
  x1: "21",
  y1: "3",
  x2: "14",
  y2: "10",
  key: "1s3k4x"
}], ["line", {
  x1: "3",
  y1: "21",
  x2: "10",
  y2: "14",
  key: "qskfes"
}]]]);
export default Maximize2;